// Palette catégorielle validée (ordre fixe, jamais recyclé) — cf. skill dataviz.
export const CATEGORICAL_COLORS = [
    '#2a78d6', // blue
    '#eb6834', // orange
    '#1baf7a', // aqua
    '#eda100', // yellow
    '#e87ba4', // magenta
    '#008300', // green
    '#4a3aa7', // violet
    '#e34948', // red
];

export const OTHER_COLOR = '#8a8a86';

// Rampe séquentielle (magnitude) — un seul ton, clair → foncé.
export const SEQUENTIAL_BLUE = ['#cde2fb', '#9ec5f4', '#6da7ec', '#3987e5', '#256abf', '#184f95', '#0d366b'];

// Couleur d'accent pour un graphique à série unique (pas de légende nécessaire).
export const SINGLE_SERIES_COLOR = '#eb6834';

export function colorForIndex(index) {
    return index < CATEGORICAL_COLORS.length ? CATEGORICAL_COLORS[index] : OTHER_COLOR;
}

export function sequentialColorForRatio(ratio) {
    const clamped = Math.max(0, Math.min(1, ratio));
    const index = Math.round(clamped * (SEQUENTIAL_BLUE.length - 1));
    return SEQUENTIAL_BLUE[index];
}
